import { useEffect, useState } from "react";

export const useIsMobile = (breakpoint = 768, maxHeight = 850) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < breakpoint || window.innerHeight < maxHeight
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint || window.innerHeight < maxHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint, maxHeight]);

  return isMobile;
};